import { CharacterMintResponse } from '../../types/character';

export const mintCharacterModel = (response: CharacterMintResponse): CharacterMintResponse => response;
